var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
// eslint-disable-next-line no-unused-vars
import AceEditor from "react-ace";
import "brace/mode/json";
import "brace/theme/github";
import LoadingScreen from "../shared/loading";
import SyncModal from "./syncModal";
import SaveButton from "../shared/saveButton";
import A11yHelpers from "../../util/A11yHelpers";
const DATA_TYPES = [
    {
        type: "java.util.List",
        // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
        isValid: (x) => Array.isArray(x),
        errorMessage: "The expected value for this field is an Array",
        // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
        parse: (x) => JSON.parse(x),
        editorSettings: {
            minLines: 2,
            maxLines: 3,
        },
    },
    {
        type: "java.lang.Boolean",
        // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
        isValid: (x) => x === true || x === false,
        // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
        parse: (x) => JSON.parse(x),
        errorMessage: "Only true || false are acceptable values",
        editorSettings: {
            minLines: 1,
            maxLines: 1,
        },
    },
    {
        type: "java.util.Map",
        // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
        isValid: (x) => Object.prototype.toString.call(x) === "[object Object]",
        // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
        parse: (x) => JSON.parse(x),
        errorMessage: "The expected value for this field is a Map",
        editorSettings: {
            minLines: 5,
            maxLines: 10,
        },
    },
    {
        type: "java.lang.String",
        // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
        isValid: (x) => x.length > 0,
        // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
        parse: (x) => JSON.parse(x),
        errorMessage: "Value required",
        editorSettings: {
            minLines: 1,
            maxLines: 1,
        },
    },
];
class Configure extends PureComponent {
    constructor(props) {
        super(props);
        console.log("Configure Props: ", props);
        this.getPropertiesForImplementation =
            this.getPropertiesForImplementation.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.save = this.save.bind(this);
        const { streamName, selectedImplementation } = props.match.params;
        this.state = {
            properties: {},
            currentProperty: {
                type: "",
                availableSelections: [],
                value: "",
                dbValue: { propertyValue: "" },
                currentValue: "",
            },
            loading: true,
            error: !streamName || !selectedImplementation,
            // @ts-expect-error - TS2322 - Type '{ properties: {}; currentProperty: { type: string; availableSelections: never[]; value: string; dbValue: { propertyValue: string; }; currentValue: string; }; loading: true; error: boolean; streamName: string; selectedImplementation: string; annotations: { ...; }[]; }' is not assignable to type 'State'.
            streamName,
            selectedImplementation,
            annotations: [
                {
                    row: 0,
                    column: 0,
                    text: "",
                    type: "warning",
                },
            ],
        };
        if (!this.state.error) {
            this.getPropertiesForImplementation();
        }
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("save()", this.state.properties);
            const response = yield fetch("/aviso/connectorConfiguration/saveConfigurationProperties", {
                method: "POST",
                credentials: "include",
                body: JSON.stringify(Object.assign({}, this.state)),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const result = yield response.json();
            console.log("/aviso/connectorConfiguration/saveConfigurationProperties", result);
        });
    }
    getPropertiesForImplementation() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch("/aviso/connectorConfiguration/getPropertiesForImplementation", {
                    method: "POST",
                    credentials: "include",
                    body: JSON.stringify(this.props.match.params),
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                const result = yield response.json();
                const { properties } = result;
                let dbValue = "";
                Object.keys(properties).forEach((key) => {
                    properties[key].inSync = true;
                    properties[key].dbValue = result.values.find(
                    // @ts-expect-error - TS7006 - Parameter 'z' implicitly has an 'any' type.
                    (z) => z.propertyName === key);
                    properties[key].value = "";
                    if (properties[key].dbValue) {
                        properties[key].value = properties[key].dbValue.propertyValue;
                        try {
                            dbValue = JSON.parse(properties[key].value);
                        }
                        catch (ex) {
                            dbValue = "";
                        }
                        properties[key].inSync = dbValue === properties[key].currentValue;
                    }
                    else {
                        properties[key].dbValue = { propertyValue: "Value Not Set" };
                    }
                });
                console.log("/aviso/connectorConfiguration/getPropertiesForImplementation ", properties);
                this.setState({ properties, loading: false });
            }
            catch (ex) {
                console.error(ex);
                this.setState({ error: true });
            }
        });
    }
    renderProperties(key) {
        return _jsx("div", { className: "card", children: this.state.properties[key].type });
    }
    onValueChange(key, value) {
        console.log(value);
        const properties = Object.assign({}, this.state.properties);
        if (!properties) {
            return;
        }
        properties[key].value = value;
        console.log("Property Value Changed: ", properties[key], value);
        const dataValidator = DATA_TYPES.find((x) => x.type === properties[key].type);
        if (!dataValidator) {
            this.setState({ properties });
            return;
        }
        try {
            const parsedObject = dataValidator.parse(value);
            if (dataValidator.isValid(parsedObject)) {
                properties[key].annotations = [];
            }
            else {
                throw dataValidator.errorMessage;
            }
        }
        catch (ex) {
            properties[key].annotations = [
                {
                    row: 0,
                    column: 0,
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    text: ex.toString(),
                    type: "error",
                },
            ];
        }
        this.setState({ properties });
    }
    renderInput(key, property) {
        const dataValidator = DATA_TYPES.find((x) => x.type === property.type);
        let aceProps = {};
        if (dataValidator) {
            aceProps = Object.assign(Object.assign({}, dataValidator.editorSettings), { mode: "json", theme: "github", 
                // @ts-expect-error - TS2339 - Property 'annotations' does not exist on type 'Property'.
                annotations: property.annotations || [], editorProps: { $useWorker: false }, 
                // @ts-expect-error - TS7006 - Parameter 'text' implicitly has an 'any' type.
                onChange: (text) => this.onValueChange(key, text), value: property.value || "", width: "100%" });
        }
        if (property.availableSelections.length > 0) {
            return (_jsxs("div", { children: [_jsx("span", { className: "text-danger", children: property.isReference
                            ? "All possible values may not be represented in this list"
                            : "" }), _jsxs("select", { onChange: (event) => this.onValueChange(key, event.target.value), value: property.value, children: [_jsx("option", { value: "" }), property.availableSelections.map((value) => (_jsx("option", { value: value, children: value }, `${key}selectList${value}`)))] })] }));
        }
        // @ts-expect-error - TS2339 - Property 'isReference' does not exist on type 'Property'.
        if (property.isReference) {
            return _jsx("span", { className: "text-danger", children: "No Available Values" });
        }
        return _jsx(AceEditor, Object.assign({}, aceProps));
    }
    setCurrentProperty(property) {
        this.setState({ currentProperty: property });
    }
    renderSync(item) {
        if (item.inSync) {
            return (_jsx("i", { "aria-hidden": "true", className: "fa fa-fw fa-refresh text-success" }));
        }
        return _jsx("i", { "aria-hidden": "true", className: "fa fa-fw fa-refresh text-danger" });
    }
    render() {
        if (this.state.loading || this.state.error) {
            return (_jsx(LoadingScreen, { isLoading: this.state.loading, pageErrored: this.state.error }));
        }
        return (_jsxs("div", { className: "row", children: [Object.keys(this.state.properties).map((key) => (_jsxs("div", { className: "card card-default col-sm-12", children: [_jsx("div", { className: "card-header bordered", children: _jsx("div", { className: "header-block", style: { width: "100%" }, children: _jsx("h3", { className: "card-title", children: _jsxs("div", Object.assign({ className: "row", "data-target": "#syncModal", "data-toggle": "modal", role: "button" }, A11yHelpers.onClickOrEnterOrSpace(() => this.setCurrentProperty(this.state.properties[key])), { children: [_jsx("div", { className: "col-1", children: this.renderSync(this.state.properties[key]) }), _jsx("div", { className: "col-11", children: key
                                                    .replace(/([A-Z])/g, " $1")
                                                    .replace(/^./, (str) => str.toUpperCase())
                                                    .trim() })] })) }) }) }), _jsxs("div", { className: "card-body", children: [_jsx("h6", { className: "card-subtitle mb-2 text-muted", children: this.state.properties[key].type }), _jsx("p", { className: "card-text", children: this.state.properties[key].descriptor }), _jsx("div", { className: "row", children: this.renderInput(key, this.state.properties[key]) })] })] }, key))), _jsx(SaveButton, { onSave: this.save }), _jsx(SyncModal, { connectorValue: JSON.stringify(this.state.currentProperty.currentValue), data: { er: null }, dbValue: this.state.currentProperty.dbValue.propertyValue, header: "Current Values", id: "syncModal" })] }));
    }
}
export default Configure;
